<template>
  <div class="my-head">
    <div class="user--info">
      <img :src="user && user.portrait" alt="avatar" class="user-avatar">
      <div class="user-text">{{note}}</div>
    </div>
    <div class="motto">知识就是力量，时间就是生命</div>
  </div>
</template>

<script>
import useGetUserInfo from '@/hooks/useGetUserInfo';
import useGetNote from '@/hooks/useGetNote';

export default {
  setup() {
    const { user } = useGetUserInfo();
    const { note } = useGetNote(false);

    return {
      user,
      note
    };
  }
};
</script>

<style lang="stylus" scoped>
.my-head {
  padding 24px 16px 16px 16px

  .user--info {
    display flex
    align-items center

    .user-avatar {
      width 24px
      height 24px
      border-radius 50%
    }

    .user-text {
      margin-left 8px
      font-size 24px
      font-weight 500
      color #fff
    }
  }

  .motto {
    margin-top 12px
    font-size 14px
    color #fff
  }
}
</style>
